<div class="modal-header">
    <h5 class="modal-title">{{ title|translate }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()">
      </button>
    </div>
    <div class="modal-body">
      {{ message|translate }}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary" (click)="decline()">{{ btnCancelText|translate }}</button>
      <button type="button" class="btn btn-primary" (click)="accept()">{{ btnOkText|translate }}</button>
    </div>